import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import jwtDecode from 'jwt-decode';

import config from '../../config/enviroment';
import './styles.scss';

const AdminRedirect = ({
    tokenData,
    tokenKey,
    redirectUrl,
    imgSrc,
    neoAdmin,
}) => {
    return (
        <div className="card__redirect">
            <img
                className="card__redirect__logo"
                src={
                    neoAdmin
                        ? require('../../assets/images/neo-admin.svg')
                        : imgSrc
                }
                alt="Logo"
            />
            <div className="card__redirect__texts">
                <h6>
                    {neoAdmin ? 'Admin' : tokenData?.company?.corporateName}
                </h6>
                <p>
                    {neoAdmin
                        ? 'You are an administrator of the Neo platform. Click below to access the administrative area.'
                        : `Access the Neo platform as a user of the ${tokenData?.company?.corporateName} company.`}
                </p>
            </div>
            <Button
                className="card__redirect__button"
                variant="neoPrimary"
                onClick={() => {
                    let lastCharacter = redirectUrl.charAt(
                        redirectUrl.length - 1,
                    );

                    if (neoAdmin) {
                        window.location.href = `${config.adminURL}/#id_token=${tokenKey}`;
                    } else {
                        if (lastCharacter === '/') {
                            return (window.location.href = `${redirectUrl}#id_token=${tokenKey}`);
                        } else {
                            window.location.href = `${redirectUrl}/#id_token=${tokenKey}`;
                        }
                    }
                }}>
                Access
            </Button>
        </div>
    );
};

export default function Login() {
    const [backgroundRandom, setBackgroundRandom] = useState(
        Math.floor(Math.random() * 4 + 1),
    );
    const [backgroundFooterColorRandom, setBackgroundFooterColorRandom] =
        useState('red');
    const [requestLoading, setRequestLoading] = useState(false);
    const [errorLogin, setErrorLogin] = useState(false);
    const [errorLoginText, setErrorLoginText] = useState('');
    const [validation, setValidation] = useState(false);
    const [toggleRedirect, setToggleRedirect] = useState(false);
    const [tokenData, setTokenData] = useState({});
    const [tokenKey, setTokenKey] = useState('');
    const [redirectUrl, setRedirectUrl] = useState('');
    const [form, setForm] = useState({
        email: '',
        password: '',
        checkbox: false,
    });

    function _handleChange(e) {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
        setErrorLogin(false);
    }

    function _axiosRequest(form) {
        delete form.checkebox;
        setRequestLoading(prevState => !prevState);

        axios
            .post(`${config.authURL}login`, form)
            .then(async response => {
                let tokenKey = response?.data?.token;

                let tokenDecode = await jwtDecode(tokenKey);
                setTokenKey(tokenKey);

                if (
                    tokenDecode?.expiredPassword ||
                    tokenDecode?.expiredDigitalSignature
                ) {
                    return (window.location.href = `${config.loginURL}expired-password?token=${tokenKey}`);
                }

                if (tokenDecode) {
                    setTokenData(tokenDecode);
                } else {
                    setErrorLogin(true);
                    setRequestLoading(false);
                }
            })
            .catch(err => {
                // Seta msg de erro sem o código
                if (
                    err?.response?.data?.message &&
                    err?.response?.data?.message.includes('-')
                ) {
                    let message = err?.response?.data?.message.split(' - ');

                    if (message[1]) setErrorLoginText(message[1]);
                }

                setRequestLoading(prevState => !prevState);
                setErrorLogin(true);
            });
    }

    function _login(e) {
        e.preventDefault();
        setValidation(true);

        if (form.email !== '' && form.password !== '') {
            _axiosRequest(form);
            setValidation(false);
        }
    }

    useEffect(() => {
        if (tokenData?.company?._id && tokenKey) {
            (async () => {
                try {
                    const { data } = await axios.get(
                        `${config.adminApiURL}config/${tokenData?.company?._id}`,
                        { headers: { Authorization: `bearer ${tokenKey}` } },
                    );

                    if (data?.config?.frontend) {
                        let queryRedirect =
                            data.config.frontend.app[
                                process.env.REACT_APP_ENVIROMENT
                            ].url;

                        if (
                            window.location.search &&
                            window.location.search.split('redirect=').length > 1
                        ) {
                            let redirectPath =
                                window.location.search.split('redirect=')[1];

                            if (!redirectPath.includes('/error'))
                                queryRedirect = redirectPath;
                        }

                        setRedirectUrl(queryRedirect);

                        if (tokenData.userAdmin) {
                            setToggleRedirect(true);
                        } else {
                            window.location.href = `${queryRedirect}#id_token=${tokenKey}`;
                        }

                        setRequestLoading(false);
                    }
                } catch (e) {
                    if (
                        e?.response?.data?.message &&
                        e?.response?.data?.message.includes('-')
                    ) {
                        let message = e?.response?.data?.message.split(' - ');

                        setErrorLoginText(
                            message?.[1]
                                ? message[1]
                                : 'COD574 - Company not found',
                        );
                    }

                    setErrorLogin(true);
                }
            })();
        }
    }, [tokenData, tokenKey]);

    return (
        <div
            className={`login-body ${
                toggleRedirect ? 'align-justify-center' : ''
            }`}>
            {toggleRedirect ? (
                <>
                    <AdminRedirect
                        tokenData={tokenData}
                        tokenKey={tokenKey}
                        redirectUrl={redirectUrl}
                        imgSrc={`${config.neoURL}/images/company-logo/${tokenData?.company?._id}.svg`}
                    />
                    <AdminRedirect
                        neoAdmin
                        tokenData={tokenData}
                        tokenKey={tokenKey}
                        redirectUrl={redirectUrl}
                    />
                </>
            ) : (
                <>
                    <div
                        className="imagesWrapper"
                        key={`imagesWrapper-${backgroundRandom}`}>
                        <img
                            className="bg-img"
                            src={require(`../../assets/images/background${backgroundRandom}.png`)}
                            alt="background-img"
                        />
                        <img
                            className="bg-effect"
                            src={require(`../../assets/images/top-right-background-effect.png`)}
                            alt="background-effect"
                        />
                        {/* <div
                                className="bg-footer"
                                style={{
                                    backgroundColor: backgroundFooterColorRandom,
                                }}></div>
                            <div className="carouselWrapper">
                                <h4 className="carouselWrapper-title">Checklist</h4>
                                <p className="carouselWrapper-text">
                                    Você visualiza todos os requisitos necessários para
                                    concluir sua tarefa e selecionar ou descrever em cada
                                    uma o que foi realizado.
                                </p>
                                <a className="carouselWrapper-link" href="#">
                                    Ver as alterações
                                </a>
                                <div className="carouselWrapper-carousel">
                                    <div className="carouselWrapper-carousel-arrow mr-20">
                                        --
                                    </div>
                                    <div className="carouselWrapper-carousel-ball"></div>
                                    <div className="carouselWrapper-carousel-ball opacity"></div>
                                    <div className="carouselWrapper-carousel-ball opacity"></div>
                                    <div className="carouselWrapper-carousel-arrow ml-9">
                                        --
                                    </div>
                                </div>
                            </div> */}
                    </div>
                    <div className="loginFormWrapper">
                        <img
                            className="form-header-range"
                            src={require('../../assets/images/form-header-range.svg')}
                            alt="form-header-range"
                        />
                        <div className="loginFormContent">
                            <div className="logo">
                                <img
                                    className="logo-neo"
                                    src={require('../../assets/images/logo-neo.svg')}
                                    alt="Neo"
                                />
                                <img
                                    className="text-neo"
                                    src={require('../../assets/images/text-neo.svg')}
                                    alt="Neo"
                                />
                            </div>
                            <div className="title">
                                <h4>Log in to your account</h4>
                                <p>Enter your email/username and password</p>
                            </div>
                            {errorLogin && (
                                <Alert
                                    variant="danger"
                                    onClose={() => setErrorLogin(false)}
                                    dismissible>
                                    <p>
                                        {errorLoginText != ''
                                            ? errorLoginText
                                            : 'Unauthorized user'}
                                    </p>
                                </Alert>
                            )}
                            <Form
                                className="inputs-form"
                                onKeyPress={e =>
                                    e.key === 'Enter' && _login(e)
                                }>
                                <Form.Group className="input-email">
                                    <Form.Control
                                        required
                                        size="lg"
                                        type="email"
                                        placeholder="Email/Username"
                                        name="email"
                                        value={form.email || ''}
                                        onChange={_handleChange}
                                        isInvalid={
                                            validation && form.email === ''
                                                ? true
                                                : false
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a email/username.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Control
                                        required
                                        size="lg"
                                        type="password"
                                        placeholder="Password"
                                        name="password"
                                        value={form.password || ''}
                                        onChange={_handleChange}
                                        isInvalid={
                                            validation && form.password === ''
                                                ? true
                                                : false
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a password.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Form>
                            <Button
                                className="submit-form"
                                variant={
                                    form.email && form.password !== ''
                                        ? 'neoPrimary'
                                        : 'neoSecondary'
                                }
                                disabled={requestLoading ? true : false}
                                onClick={e => _login(e)}>
                                {requestLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    'log in'
                                )}
                            </Button>
                            <Link
                                to="/forgot-password"
                                className="forgot-password">
                                Forgot password?
                            </Link>
                        </div>
                        <div className="poweredBy">
                            <a className="by-antares" href="#">
                                powered by
                            </a>
                            <br></br>
                            <img
                                className="logo-antares"
                                src={require('../../assets/images/logo-antares.svg')}
                                alt="Antares vision group"
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
